











































































































































































































































































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
// import SideTabRight from "@/components/SideTabRight.vue";
import ConfirmDialog from "@/components/common/ConfirmDialog.vue";
import { INSPECT_TYPE } from "@/model/InspectType";
import { Getter, Action } from "vuex-class";
import { SeibiItem } from "@/model/InspectionSeibi";
import requestService from "@/service/requestService";
import Number from "@/shared/filters/Number";
import { InspectButtonValue } from "@/model/InspectButtonValue";
import { DO_SEIBI } from "@/model/DoSeibi";
import * as util from "@/service/util";
import { MESSAGE } from "@/model/Message";
import { UserService } from "@/service/UserService";
import { SocketControllers } from "@/service/SocketControllers";
import InputNumber from "@/components/common/input/InputNumber.vue";
import UserFooter from "@/components/UserFooter.vue";
import { EditPriceParam } from "@/model/EditPriceParam";
import TopBarTitle from "@/components/common/TopBarTitle.vue";
import { STATUS_SELECT_WORK_BUHIN } from "@/model/StatusSelectWorkBuhin";
import { ElButton } from "element-ui/types/button";
export interface SideTab {
  status: boolean;
}

@Component({
  filters: {
    Number
  },
  components: {
    // appSideTabRight: SideTabRight,
    ConfirmDialog,
    InputNumber,
    UserFooter,
    TopBarTitle
  }
})
export default class InspectList extends Vue {
  isEditPrice: boolean = false;
  showAside: boolean = true;
  inspectType: number = INSPECT_TYPE.LEGAL56;
  reqService: requestService;
  sktControll: SocketControllers;
  indexTooltip: number = -1;
  listSeibi: SeibiItem[] = [];
  showPriceList: SeibiItem[] = [];
  totalPriceZn: number = 0;
  totalPriceZk: number = 0;
  isGoToRevNum: boolean = false;
  isSave: boolean = false;
  textTopTitle: string = "";
  manualBuhinNm: string = "";
  manualBuhinKn: number | null = null;
  tmpDeleteWorkIndex: number = -1;
  sknUketsukeManualSeibiId: any = 0;
  $refs!: {
    confirmDialog: ConfirmDialog;
    confirmDialog2: ConfirmDialog;
    // sideTab: SideTabRight;
    userFooter: UserFooter;
    askDeleteDialog: ConfirmDialog;
    buttonAddWork: ElButton;
    manualBuhinKn: InputNumber;
  };

  loadingText: string = MESSAGE.Loading;
  // 2022-01-31 morisako kobac-free mod [START]
  freeOfChargeNm: string = '無償対応';
  // 2022-01-31 morisako kobac-free mod [END]

  @Prop() onUserConfirmUpdating: boolean;

  @Action("setSeibiData", { namespace: "InspectSeibi" })
  setSeibiData: any;

  @Action("setListInspectId", { namespace: "InspectSeibi" })
  setListInspectId: any;

  @Action("editPrice", { namespace: "InspectSeibi" })
  editPrice: any;

  @Action("updateDotenken", { namespace: "InspectSeibi" })
  updateDotenken: any;

  @Action("updateDoTenken", { namespace: "InspectSeibiAK3" })
  updateDoTenkenAk3: any;

  @Action("updateDoTenkenFromSocket", { namespace: "InspectSeibi" })
  updateDoTenkenFromSocket: any;

  @Action("confirm", { namespace: "InspectSeibi" })
  confirm: any;

  @Getter("uketsukeExtendsId", { namespace: "ReservationDetail" })
  uketsukeExtendsId: number;

  @Getter("listInspectByType", { namespace: "InspectSeibi" })
  listInspect!: (inspectType: number) => SeibiItem[];

  @Getter("sumPriceByType", { namespace: "InspectSeibi" })
  sumPrice!: (inspectType: number) => any;

  @Getter("hasData", { namespace: "InspectSeibi" })
  hasData: boolean;

  @Getter("getSeibiData", { namespace: "InspectSeibi" })
  seibiData: SeibiItem[][];
  @Getter("yoyakuNo", { namespace: "ReservationDetail" })
  yoyakuNo: string;

  @Getter("uketsukeCd", { namespace: "ReservationDetail" })
  uketsukeCd: string;

  @Action("setProgressState", { namespace: "SubHeader" })
  setProgressState: any;

  @Getter("seibiLoading", { namespace: "UserDataState" })
  isLoading: boolean;

  @Action("setSeibiData", { namespace: "InspectSeibiAK3" })
  setSeibiAK3Data: any;

  @Getter("isConfirmLegal56", { namespace: "InspectSeibi" })
  isConfirmLegal56: any;

  @Getter("isConfirmRecommend", { namespace: "InspectSeibi" })
  isConfirmRecommend: any;

  @Getter("isConfirm", { namespace: "Payment" })
  isConfirmPayment: any;

  /** 2023-10-19 invoice [START] */
  @Getter("isExcludingTax", { namespace: "FunctionSetting" })
  isExcludingTax: any;
  @Getter("taxLabel", { namespace: "FunctionSetting" })
  taxLabel: string;
  /** 2023-10-19 invoice [END] */

  /** 2023-12-01 jizen-mitsumori , sync sort-order [START] */
  @Getter("isCanJizenMitsumori", { namespace: "FunctionSetting" })
  isCanJizenMitsumori: any;
  /** 2023-12-01 jizen-mitsumori , sync sort-order [END] */

  /** 2023-05-01 sh #8240(BQR1090) add clearTimeout for notify. [START] */
  timeId: any = null;
  /** 2023-05-01 sh #8240(BQR1090) add clearTimeout for notify. [END] */

  @Watch("$route")
  onRouteChange(to: any, from: any) {
    this.setInspectType(to.name);
    this.$nextTick(() => {
      this.initPage();
    });
  }

  @Watch("seibiData")
  onSeibiDataChange(to: any, from: any) {
    this.setListSeibi();
    this.setIndexTooltip();
  }

  // @Watch("isEditPrice")
  // onIsEditPriceChange(to: any, from: any) {
  //   if (from && !to) {
  //     this.updatePrice();
  //   }
  // }

  /** 2024-03-01 sh #8804(BQRxxx) 赤画面△の「する」「しない」選択操作をした際に 勝手に他部位の「する」「しない」が動く。 MFノースジャパン様 No.25 [START] */
  timerSave: any = null;
  /** 2024-03-01 sh #8804(BQRxxx) 赤画面△の「する」「しない」選択操作をした際に 勝手に他部位の「する」「しない」が動く。 MFノースジャパン様 No.25 [END] */

  created() {
    this.reqService = new requestService();
    this.sktControll = new SocketControllers();
    this.sktControll.connectSocket(this.onConnect);
  }

  mounted() {
    if (this.$route.name) {
      this.setInspectType(this.$route.name);
      this.initPage();
    }
  }

  onClickEdit(isEdit: boolean) {
    this.listSeibi.forEach((item: any, index: number) => {
      if (item.kousuu < 0 && item.kouchinEditZk != this.showPriceList[index].kouchinEditZk) {
        if (!isEdit) {
          this.updatePrice();
        }
      }
    });
    this.isEditPrice = isEdit;
  }

  setListSeibi() {
    // 2023-10-00 BQR1092(809) add 明細の並び順とextreme取込 [START]
    this.reqService.checkJizenSort(this.uketsukeExtendsId).then((res: any) => {
      let isJizenSort = "true" === res.toString();
      if (isJizenSort) {
        let seibi = JSON.parse(JSON.stringify(this.seibiData));
        if (seibi && seibi.length > 0) {
          let index = 0;
          if (this.inspectType === INSPECT_TYPE.RECOMMEND) index = 4;
          this.listSeibi = seibi[index];
        }
      } else {
      // 2023-10-00 BQR1092(809) add 明細の並び順とextreme取込 [END]
        this.listSeibi = this.listInspect(this.inspectType);
      // 2023-10-00 BQR1092(809) add 明細の並び順とextreme取込 [START]
      }
      // 2023-10-00 BQR1092(809) add 明細の並び順とextreme取込 [END]
      this.showPriceList = util.deepCopy(this.listSeibi);
      this.showPriceList.forEach((item: any) => {
        if (item.kouchinEditZk < 0) {
          item.kouchinEditZk = 0;
          item.kouchinEditZn = 0;
          item.kouchinZk = 0;
          item.kouchinZn = 0;
        }
      });
      /** 2023-10-19 invoice [START] */
      this.totalPriceZn = this.sumPrice(this.inspectType).totalZn;
      this.totalPriceZk = this.sumPrice(this.inspectType).totalZk;
  	  /** 2023-10-19 invoice [END] */
    // 2023-10-00 BQR1092(809) add 明細の並び順とextreme取込 [START]
    });
    // 2023-10-00 BQR1092(809) add 明細の並び順とextreme取込 [END]
  }

  get isRecommend() {
    return this.inspectType == INSPECT_TYPE.RECOMMEND;
  }

  setInspectType(routeName: string) {
    if (routeName != 'estimate') {
    if (routeName == "userlegal56") {
      this.inspectType = INSPECT_TYPE.LEGAL56;
    } else {
      this.inspectType = INSPECT_TYPE.RECOMMEND;
    }
    }
  }

  initPage() {
    if (this.$route.name != 'estimate') {
    if (this.inspectType == INSPECT_TYPE.LEGAL56) {
      this.textTopTitle = "法定57項目検査の結果";
    } else {
      this.textTopTitle = "おすすめ整備点検の結果";
    }
    } else {
      this.textTopTitle = "現車・法定57項目検査の結果";
    }
    let index;
    if (this.inspectType == INSPECT_TYPE.LEGAL56) {
      index = 2;
    } else {
      index = 3;
    }
    if (window.sessionStorage.getItem("seibiEditMode" + this.inspectType)) {
      this.isEditPrice = true;
      window.sessionStorage.removeItem("seibiEditMode" + this.inspectType);
    } else {
      this.isEditPrice = false;
    }
    // if (this.$refs.sideTab) {
    //   this.$refs.sideTab.onActive(index);
    // }
    this.$emit("onActiveSideTab", index);
  // 2022-01-31 morisako kobac-free add [START]
    this.getFreeOfChargeNm();
  // 2022-01-31 morisako kobac-free add [END]
    this.getSeibi();
  }

  getSeibi() {
    if (this.hasData) {
      this.setListSeibi();
      this.setIndexTooltip();
    } else if (!this.isLoading) {
      const userService = new UserService();
      userService.getAllData();
    }
  }

  setIndexTooltip() {
    console.log("setIndexTooltip")
    if (this.inspectType == INSPECT_TYPE.LEGAL56) {
      if (this.listSeibi.length > 0) {
        let index = this.listSeibi.filter(
          (item: SeibiItem) => item.inspectResult == InspectButtonValue.CROSS
        ).length;
        if (this.listSeibi[index] && this.listSeibi[index].doTenken == 0) {
          this.indexTooltip = index;
        }
      }
    } else {
      this.indexTooltip = -1;
    }
  }

  isTriangle(item: SeibiItem) {
    if (this.inspectType == INSPECT_TYPE.LEGAL56) {
      return item.inspectResult == InspectButtonValue.TRIANGLE;
    }
    return false;
  }

  isCross(item: SeibiItem) {
    if (this.inspectType == INSPECT_TYPE.LEGAL56) {
      return item.inspectResult == InspectButtonValue.CROSS;
    }
    return false;
  }

  isMid(item: SeibiItem) {
    if (this.inspectType == INSPECT_TYPE.RECOMMEND || this.inspectType == INSPECT_TYPE.RECOMMEND_MANUAL) {
      return item.inspectResult == InspectButtonValue.TRIANGLE;
    }
    return false;
  }

  isHigh(item: SeibiItem) {
    if (this.inspectType == INSPECT_TYPE.RECOMMEND || this.inspectType == INSPECT_TYPE.RECOMMEND_MANUAL) {
      return item.inspectResult == InspectButtonValue.CROSS;
    }
    return false;
  }

  isLow(item: SeibiItem) {
    if (this.inspectType == INSPECT_TYPE.RECOMMEND || this.inspectType == INSPECT_TYPE.RECOMMEND_MANUAL) {
      return item.inspectResult == InspectButtonValue.CIRCLE;
    }
    return false;
  }

  isFree(item: SeibiItem) {
    if (this.inspectType == INSPECT_TYPE.RECOMMEND || this.inspectType == INSPECT_TYPE.RECOMMEND_MANUAL) {
      return item.inspectResult == InspectButtonValue.FREE;
    }
    return false;
  }

  isSuru(item: SeibiItem) {
    return (
      item.doTenken == DO_SEIBI.suru
      //  || item.inspectResult == InspectButtonValue.CROSS
    );
  }

  isShinai(item: SeibiItem) {
    return item.doTenken == DO_SEIBI.shinai;
  }

  isGojitsu(item: SeibiItem) {
    return item.doTenken == DO_SEIBI.gojitsu;
  }

  showTextStatus(item: SeibiItem) {
    if (this.isRecommend) {
      if (this.isMid(item)) {
        return "中";
      } else if (this.isHigh(item)){
        return "高";
      } else if (this.isLow(item)){
        return "低";
      } else {
        return "F";
      }
    }
    return "";
  }

  onCancelSavePrice() {
    if (this.isEditPrice) {
      this.showPriceList.map((data: any, index: number) => {
        data.kouchinEditZk = this.listSeibi[index].kouchinEditZk;
        data.buhinEditTotalZk = this.listSeibi[index].buhinEditTotalZk;
      });
      this.isEditPrice = false;
      if (this.isGoToRevNum) {
        this.$refs.userFooter.onSave();
      } else {
        setTimeout(() => {
          this.$refs.confirmDialog.onOpen();
        }, 200);
      }
    }
  }

  onConfirm() {
    if (this.isEditPrice) {
      this.$refs.confirmDialog2.onOpen();
    } else {
      this.$refs.confirmDialog.onOpen();
    }
  }

  nextPage() {
    if (
      (this.inspectType == INSPECT_TYPE.LEGAL56 && this.isConfirmLegal56 === 0) ||
      (this.inspectType == INSPECT_TYPE.RECOMMEND && this.isConfirmRecommend === 0)
    ) {
      const isConfirmInspect =
        this.inspectType == INSPECT_TYPE.LEGAL56 ? 1 : this.isConfirmLegal56;
      const isConfirmRecommend =
        this.inspectType == INSPECT_TYPE.RECOMMEND
          ? 1
          : this.isConfirmRecommend;
      const param = {
        sknUketsukeExtendsId: this.uketsukeExtendsId,
        isConfirmInspect,
        isConfirmRecommend,
        isConfirmPayment: this.isConfirmPayment
      };
      this.reqService.saveIsConfirm(param).then(() => {
        this.processNextPage();
      }, (error: any) => {
        this.$notify.info({
          title: "エラー",
          message: MESSAGE.SystemError
        });
      });
    } else {
      this.processNextPage();
    }
  }

  processNextPage() {
    let index = this.inspectType == INSPECT_TYPE.LEGAL56 ? 2 : 3;
    //this.$refs.sideTab.onConfirm(index);
    this.$emit("onConfirmSideTab", index);
    this.confirm({ type: this.inspectType, value: 1 });
    this.$emit("onUserConfirm");
    let listRecommend = this.listInspect(INSPECT_TYPE.RECOMMEND);
    if (this.inspectType == INSPECT_TYPE.LEGAL56 && listRecommend.length > 0) {
      this.$emit("onTopTitle", "おすすめ整備点検の結果");
      this.$router.push({ name: "userrecommend" });
    } else {
      this.$router.push({ name: "paymentdetail" });
    }
  }

  nextPage2() {
    if (this.isEditPrice) {
      this.updatePrice();
      this.$emit("update:isEditPrice", false);
      if (this.isGoToRevNum) {
        this.$refs.userFooter.onSave();
      } else {
        setTimeout(() => {
          this.$refs.confirmDialog.onOpen();
        }, 200);
      }
    }
  }

  updatePrice() {//金額変更
    this.listSeibi.map((data: SeibiItem, index: number) => {
      let newdata:any = {};
      if (
        data.kouchinEditZk != this.showPriceList[index].kouchinEditZk ||
        data.buhinEditTotalZk != this.showPriceList[index].buhinEditTotalZk
      ) {
//        data.kouchinEditZk = this.showPriceList[index].kouchinEditZk;
//        data.buhinEditTotalZk = this.showPriceList[index].buhinEditTotalZk;
//        this.updateDotenken(data);
//        let paramUpdate = {} as EditPriceParam;
//        paramUpdate.sknUketsukeExtendsId = this.uketsukeExtendsId;
//        let buhinEditTotalZk =
//          data.buhinEditTotalZk == data.buhinZk
//            ? null
//            : data.buhinEditTotalZk || 0;
//        let kouchinEditZk =
//          data.kouchinEditZk == data.kouchinZk ? null : data.kouchinEditZk || 0;
//        paramUpdate.kouchinEditZk = kouchinEditZk;
//        paramUpdate.buhinEditTotalZk = buhinEditTotalZk;

       newdata.kouchinZk = this.showPriceList[index].kouchinEditZk;
       newdata.buhinZk = this.showPriceList[index].buhinEditTotalZk;
       newdata.kouchinZn = this.showPriceList[index].kouchinEditZn;
       newdata.buhinZn = this.showPriceList[index].buhinEditTotalZn;

//        if (data.sknUketsukeManualSeibiId) {
//          paramUpdate.sknUketsukeInspectSeibiManualId =
//            data.sknUketsukeManualSeibiId;
//        // 2023-10-00 BQR1092(809) add 明細の並び順とextreme取込 [START]
//        } else if (data.sknInspectType == INSPECT_TYPE.USER_MANUAL) {
//          paramUpdate.sknUketsukeInspectSeibiManualId = data.sknInspectSeibiId;
//        //  data.kouchinEditZk = kouchinEditZk;
//        //  data.buhinEditTotalZk = buhinEditTotalZk;
//        } else if (data.sknInspectDescriptionSeibiId == 0) {
//          paramUpdate.sknUketsukeInspectSeibiManualId = data.sknInspectSeibiId;
//        //  data.kouchinEditZk = kouchinEditZk;
//        //  data.buhinEditTotalZk = buhinEditTotalZk;
//        // 2023-10-00 BQR1092(809) add 明細の並び順とextreme取込 [START]
//        } else {
//          paramUpdate.sknUketsukeInspectSeibiId = data.sknInspectSeibiId;
//        }
//        /** 2021-05-27 sh #7123 if change price, change the flag. [START] */
//        if (this.inspectType == INSPECT_TYPE.RECOMMEND && this.isConfirmRecommend){
//          this.saveIsConfirmRecommend();
//        }
//        if (this.inspectType == INSPECT_TYPE.LEGAL56 && this.isConfirmLegal56){
//          this.saveIsConfirmInspect();
//        }
/*        
        //事前見積もりONの時の手入力の構造違いにより金額更新の構造も変化する
        if (this.inspectType == INSPECT_TYPE.RECOMMEND && data.inspectResult == INSPECT_TYPE.RECOMMEND_MANUAL){
          this.reqService.checkJizenSort(this.uketsukeExtendsId).then((res: any) => {
            let isJizenSort = "true" === res.toString();
            if (isJizenSort) {
              const body: any = {
                sknUketsukeExtendsId : data.sknUketsukeExtendsId,
                sknUketsukeInspectSeibiId : data.sknInspectSeibiId,
                sknUketsukeInspectSeibiManualId : null,
                buhinEditTotalZk : data.buhinEditTotalZk,
                buhinEditTotalZn : data.buhinEditTotalZn,
                kouchinEditZk : data.kouchinEditZk, 
                kouchinEditZn : data.kouchinEditZn
              }
              this.editPrice(body);
              //this.setSeibiData(this.listSeibi);
            }
          });
        }
*/
        /** 2021-05-27 sh #7123 if change price, change the flag. [END] */
//        this.reqUpdatePrice(paramUpdate);
        this.reqUpdatePriceSetData(data,index,newdata,1);
      /** 2023-10-19 invoice [START] */
      }else if (
        data.kouchinEditZn != this.showPriceList[index].kouchinEditZn ||
        data.buhinEditTotalZn != this.showPriceList[index].buhinEditTotalZn
      ) {

//        data.kouchinEditZn = this.showPriceList[index].kouchinEditZn;
//        data.buhinEditTotalZn = this.showPriceList[index].buhinEditTotalZn;
//        this.updateDotenken(data);
//        let paramUpdate = {} as EditPriceParam;
//        paramUpdate.sknUketsukeExtendsId = this.uketsukeExtendsId;
        
        
//        let buhinEditTotalZn =
//          data.buhinEditTotalZn == data.buhinZn
//            ? null
//            : data.buhinEditTotalZn || 0;
//        let kouchinEditZn =
//          data.kouchinEditZn == data.kouchinZn ? null : data.kouchinEditZn || 0;
//        paramUpdate.kouchinEditZn = kouchinEditZn;
//        paramUpdate.buhinEditTotalZn = buhinEditTotalZn;
        newdata.kouchinZk = this.showPriceList[index].kouchinEditZk;
       newdata.buhinZk = this.showPriceList[index].buhinEditTotalZk;
       newdata.kouchinZn = this.showPriceList[index].kouchinEditZn;
       newdata.buhinZn = this.showPriceList[index].buhinEditTotalZn;
//        if (data.sknUketsukeManualSeibiId) {
//          paramUpdate.sknUketsukeInspectSeibiManualId =
//            data.sknUketsukeManualSeibiId;
//        // 2023-10-00 BQR1092(809) add 明細の並び順とextreme取込 [START]
//        } else if (data.sknInspectType == INSPECT_TYPE.USER_MANUAL) {
//          paramUpdate.sknUketsukeInspectSeibiManualId = data.sknInspectSeibiId;
//        //  data.kouchinEditZn = kouchinEditZn;
//        //  data.buhinEditTotalZn = buhinEditTotalZn;
//        } else if (data.sknInspectDescriptionSeibiId == 0) {
//          paramUpdate.sknUketsukeInspectSeibiManualId = data.sknInspectSeibiId;
//        //  data.kouchinEditZn = kouchinEditZn;
//        //  data.buhinEditTotalZn = buhinEditTotalZn;
//        // 2023-10-00 BQR1092(809) add 明細の並び順とextreme取込 [START]
//        } else {
//          paramUpdate.sknUketsukeInspectSeibiId = data.sknInspectSeibiId;
//        }
//        /** 2021-05-27 sh #7123 if change price, change the flag. [START] */
//        if (this.inspectType == INSPECT_TYPE.RECOMMEND && this.isConfirmRecommend){
//          this.saveIsConfirmRecommend();
//        }
//        if (this.inspectType == INSPECT_TYPE.LEGAL56 && this.isConfirmLegal56){
//          this.saveIsConfirmInspect();
//        }
//        /** 2021-05-27 sh #7123 if change price, change the flag. [END] */
//        this.reqUpdatePrice(paramUpdate);
        this.reqUpdatePriceSetData(data,index,newdata,2);
	  /** 2023-10-19 invoice [END] */
      }
    });
  }

  reqUpdatePriceSetData(seibi: SeibiItem, index: number,data:any,type: number) {
    let paramUpdate = {} as EditPriceParam;
    paramUpdate.sknUketsukeExtendsId = this.uketsukeExtendsId;
    //let paramUpdate: any = {
    //  sknUketsukeExtendsId: this.uketsukeExtendsId
    //};
    let doUpdate = false;

    ////税込み税抜きを同時処理する
    //if ((seibi.kouchinEditZk != null || seibi.buhinEditTotalZk != null) &&
    //  (seibi.kouchinEditZk != seibi.kouchinZk || seibi.buhinEditTotalZk != seibi.buhinZk)) {
    //  seibi.kouchinEditZk = seibi.kouchinZk;
    //  seibi.buhinEditTotalZk = seibi.buhinZk;
    //  this.showPriceList[index].kouchinEditZk = seibi.kouchinZk;
    //  this.showPriceList[index].buhinEditTotalZk = seibi.buhinZk;
//
    //  paramUpdate.kouchinEditZk = seibi.kouchinZk ;
    //  paramUpdate.buhinEditTotalZk = seibi.buhinZk ;
    //  doUpdate = true; //更新実行
    //}
    if( type == 1 && ( seibi.kouchinEditZk != data.kouchinZk || seibi.buhinEditTotalZk != data.buhinZk ) ) {
      seibi.kouchinEditZk = data.kouchinZk;
      seibi.buhinEditTotalZk = data.buhinZk;
      paramUpdate.kouchinEditZk = data.kouchinZk  == seibi.kouchinZk ? null : data.kouchinZk || 0;
      paramUpdate.buhinEditTotalZk = data.buhinZk == seibi.buhinZk ? null : data.buhinZk || 0;
      doUpdate = true; //更新実行
    }else if ((seibi.kouchinEditZk != null || seibi.buhinEditTotalZk != null) &&
      (seibi.kouchinEditZk != data.kouchinZk || seibi.buhinEditTotalZk != data.buhinZk)) {
      seibi.kouchinEditZk = data.kouchinZk;
      seibi.buhinEditTotalZk = data.buhinZk;
      this.showPriceList[index].kouchinEditZk = data.kouchinZk;
      this.showPriceList[index].buhinEditTotalZk = data.buhinZk;
      paramUpdate.kouchinEditZk = data.kouchinZk ;
      paramUpdate.buhinEditTotalZk = data.buhinZk ;
      doUpdate = true; //更新実行
    }
    //if ((seibi.kouchinEditZn != null || seibi.buhinEditTotalZn != null) &&
    //  (seibi.kouchinEditZn != seibi.kouchinZn || seibi.buhinEditTotalZn != seibi.buhinZn)) {
    //  seibi.kouchinEditZn = seibi.kouchinZn;
    //  seibi.buhinEditTotalZn = seibi.buhinZn;
    //  this.showPriceList[index].kouchinEditZn = seibi.kouchinZn;
    //  this.showPriceList[index].buhinEditTotalZn = seibi.buhinZn;
//
    //  paramUpdate.kouchinEditZn = seibi.kouchinZn ;
    //  paramUpdate.buhinEditTotalZn = seibi.buhinZn ;
    //  doUpdate = true; //更新実行
    //}
    if( type == 2 && ( seibi.kouchinEditZn != data.kouchinZn || seibi.buhinEditTotalZn != data.buhinZn ) ) {
      seibi.kouchinEditZn = data.kouchinZn
      seibi.buhinEditTotalZn = data.buhinZn;
      paramUpdate.kouchinEditZn = data.kouchinZn  == seibi.kouchinZn ? null : data.kouchinZn || 0;
      paramUpdate.buhinEditTotalZn = data.buhinZn == seibi.buhinZn ? null : data.buhinZn || 0;
      doUpdate = true; //更新実行
    }else if ((seibi.kouchinEditZn != null || seibi.buhinEditTotalZn != null) &&
      (seibi.kouchinEditZn != data.kouchinZn || seibi.buhinEditTotalZn != data.buhinZn)) {
      seibi.kouchinEditZn = data.kouchinZn;
      seibi.buhinEditTotalZn = data.buhinZn;
      this.showPriceList[index].kouchinEditZn = data.kouchinZn;
      this.showPriceList[index].buhinEditTotalZn = data.buhinZn;
      paramUpdate.kouchinEditZn = data.kouchinZn ;
      paramUpdate.buhinEditTotalZn = data.buhinZn ;
      doUpdate = true; //更新実行
    }

    if ( doUpdate ){
      this.updateDotenken(seibi);

      if (seibi.sknUketsukeManualSeibiId) {
        paramUpdate.sknUketsukeInspectSeibiManualId = seibi.sknUketsukeManualSeibiId;
      } else if (seibi.sknInspectType == INSPECT_TYPE.USER_MANUAL) {
        paramUpdate.sknUketsukeInspectSeibiManualId = seibi.sknInspectSeibiId;
      } else if (seibi.sknInspectDescriptionSeibiId == 0) {
        paramUpdate.sknUketsukeInspectSeibiManualId = seibi.sknInspectSeibiId;
      } else {
        paramUpdate.sknUketsukeInspectSeibiId = seibi.sknInspectSeibiId;
      }
      /** 2021-05-27 sh #7123 if change price, change the flag. [START] */
      if (this.inspectType == INSPECT_TYPE.RECOMMEND && this.isConfirmRecommend){
        this.saveIsConfirmRecommend();
      }
      if (this.inspectType == INSPECT_TYPE.LEGAL56 && this.isConfirmLegal56){
        this.saveIsConfirmInspect();
      }

      //type=1限定：事前見積もりONの時の手入力の構造違いにより金額更新の構造も変化する
      if (type == 1 && this.inspectType == INSPECT_TYPE.RECOMMEND && seibi.inspectResult == INSPECT_TYPE.RECOMMEND_MANUAL){
        this.reqService.checkJizenSort(this.uketsukeExtendsId).then((res: any) => {
          let isJizenSort = "true" === res.toString();
          if (isJizenSort) {
            const body: any = {
              sknUketsukeExtendsId : seibi.sknUketsukeExtendsId,
              sknUketsukeInspectSeibiId : seibi.sknInspectSeibiId,
              sknUketsukeInspectSeibiManualId : null,
              buhinEditTotalZk : data.buhinZk,
              buhinEditTotalZn : data.buhinZn,
              kouchinEditZk : data.kouchinZk, 
              kouchinEditZn : data.kouchinZn
            }
            this.editPrice(body);
            //this.setSeibiData(this.listSeibi);
          }
        });
      }
      
      this.reqUpdatePrice(paramUpdate);
    }
  }

//小計更新
  reqUpdatePrice(paramUpdate: any) {
    this.isSave = true;
    this.reqService.updatePrice(paramUpdate);
    /** 2023-10-19 invoice [START] */
    this.totalPriceZn = this.sumPrice(this.inspectType).totalZn;
    this.totalPriceZk = this.sumPrice(this.inspectType).totalZk;
    /** 2023-10-19 invoice [END] */
    let page = this.inspectType == INSPECT_TYPE.LEGAL56 ? 2 : 3;
    //this.$refs.sideTab.onUpdate(page);
    this.$emit("onUpdateSideTab", page);
  }

  resetPrice(seibi: SeibiItem, index: number) {
      let data:any = {};
//    let paramUpdate: any = {
//      sknUketsukeExtendsId: this.uketsukeExtendsId
//    };
//    let doUpdate = false;
//
//    //税込み税抜きを同時処理する
//    if ((seibi.kouchinEditZk != null || seibi.buhinEditTotalZk != null) &&
//      (seibi.kouchinEditZk != seibi.kouchinZk || seibi.buhinEditTotalZk != seibi.buhinZk)) {
//      seibi.kouchinEditZk = seibi.kouchinZk;
//      seibi.buhinEditTotalZk = seibi.buhinZk;
//      this.showPriceList[index].kouchinEditZk = seibi.kouchinZk;
//      this.showPriceList[index].buhinEditTotalZk = seibi.buhinZk;
//
//      paramUpdate.kouchinEditZk = seibi.kouchinZk ;
//      paramUpdate.buhinEditTotalZk = seibi.buhinZk ;
//      doUpdate = true; //更新実行
//    }
//    if ((seibi.kouchinEditZn != null || seibi.buhinEditTotalZn != null) &&
//      (seibi.kouchinEditZn != seibi.kouchinZn || seibi.buhinEditTotalZn != seibi.buhinZn)) {
//      seibi.kouchinEditZn = seibi.kouchinZn;
//      seibi.buhinEditTotalZn = seibi.buhinZn;
//      this.showPriceList[index].kouchinEditZn = seibi.kouchinZn;
//      this.showPriceList[index].buhinEditTotalZn = seibi.buhinZn;
//
//      paramUpdate.kouchinEditZn = seibi.kouchinZn ;
//      paramUpdate.buhinEditTotalZn = seibi.buhinZn ;
//      doUpdate = true; //更新実行
//    }
      data.kouchinZk = seibi.kouchinZk;
      data.buhinZk = seibi.buhinZk;
      data.kouchinZn = seibi.kouchinZn;
      data.buhinZn = seibi.buhinZn;
//
//    if ( doUpdate ){
//      this.updateDotenken(seibi);
//
//      if (seibi.sknUketsukeManualSeibiId) {
//        paramUpdate.sknUketsukeInspectSeibiManualId = seibi.sknUketsukeManualSeibiId;
//      } else if (seibi.sknInspectType == INSPECT_TYPE.USER_MANUAL) {
//        paramUpdate.sknUketsukeInspectSeibiManualId = seibi.sknInspectSeibiId;
//      } else if (seibi.sknInspectDescriptionSeibiId == 0) {
//        paramUpdate.sknUketsukeInspectSeibiManualId = seibi.sknInspectSeibiId;
//      } else {
//        paramUpdate.sknUketsukeInspectSeibiId = seibi.sknInspectSeibiId;
//      }
//      /** 2021-05-27 sh #7123 if change price, change the flag. [START] */
//      if (this.inspectType == INSPECT_TYPE.RECOMMEND && this.isConfirmRecommend){
//        this.saveIsConfirmRecommend();
//      }
//      if (this.inspectType == INSPECT_TYPE.LEGAL56 && this.isConfirmLegal56){
//        this.saveIsConfirmInspect();
//      }
//      /** 2021-05-27 sh #7123 if change price, change the flag. [END] */
//      this.reqUpdatePrice(paramUpdate);
      
//    }
    this.reqUpdatePriceSetData(seibi,index,data,0);

  }



  goBack() {
    this.$emit("onTopTitle", "法定57項目検査の結果");
    this.$router.go(-1);
  }

  clickDoTenken(
    item: SeibiItem,
    doTenken: number,
    index: number,
    isSave: boolean = true
    , isAll: boolean = false
  ) {
    let flg = true;
    if (!isAll && this.inspectType ==2 && item.rowNum == 0 && doTenken == 1) {
      this.listSeibi.forEach((seibi: any) => {
        if (seibi.sknInspectDescriptionSeibiId == 0 && seibi.doTenken != 1) {
          flg = false;
        }
      });
    }
    if (flg) {
    if (item.doTenken == doTenken) {
      return;
    }
    if (item) {
      if (item.inspectResult != InspectButtonValue.CROSS) {
        this.indexTooltip = -1;
      }
      item.doTenken = doTenken;
      if (this.isEditPrice && index >= 0 && doTenken != 1) {
        this.showPriceList[index].kouchinEditZk = this.listSeibi[
          index
        ].kouchinEditZk;
        this.showPriceList[index].buhinEditTotalZk = this.listSeibi[
          index
        ].buhinEditTotalZk;
      }
      this.updateDotenken(item);
      // this.updateDoTenkenAk3(item);
      /** 2023-10-19 invoice [START] */
      this.totalPriceZn = this.sumPrice(this.inspectType).totalZn;
      this.totalPriceZk = this.sumPrice(this.inspectType).totalZk;
      /** 2023-10-19 invoice [END] */
      let page;
      if (this.inspectType == INSPECT_TYPE.LEGAL56) {
        page = 2;
      } else {
        page = 3;
      }
      // this.$refs.sideTab.onUpdate(page);
      this.$emit("onUpdateSideTab", page);
      /** 2023-03-28 sh #8188(BQR1084) course does not work for recommend. [START] */
      // if (isSave) {
      //   this.isSave = true;
      //   this.reqService.updateDoTenken(
      //       this.uketsukeExtendsId,
      //       doTenken,
      //       item.sknInspectId,
      //       item.sknInspectSeibiId,
      //       item.sknUketsukeManualSeibiId
      //     ).then(
      //       res => {
      //         const userService = new UserService();
      //         userService.autoSaveAk7();
      //       },
      //       error => {
      //         this.$notify.error({
      //           title: "エラー",
      //           message: MESSAGE.SystemError
      //         });
      //       }
      //     );
      // }
      // if (!isAll && this.inspectType ==2 && item.sknInspectDescriptionSeibiId == 0) {
      //   this.listSeibi.forEach((seibi: any, i: number) => {
      //     if (seibi.rowNum == 0 && item.sknRecommendInspectCategoryId == seibi.sknRecommendInspectCategoryId) this.clickDoTenken(seibi,doTenken,i, isSave, true);
      //   });
      // }
      if (!isAll) {
        this.updateDoTenkenCallApi(item, doTenken, isSave);
      }
      /** 2023-03-28 sh #8188(BQR1084) course does not work for recommend. [END] */
    }
    } else {
      /** 2023-10-00 add ユーザー画面から手入力した作業が実施状況変更できない修正 [START] */
      if (item.sknInspectType == INSPECT_TYPE.USER_MANUAL) {
        this.updateDoTenkenCallApi(item, doTenken, isSave);
      }
      /** 2023-10-00 add ユーザー画面から手入力した作業が実施状況変更できない修正 [END] */
      /** 2021-05-27 sh #7123 if change price, change the flag. [START] */
      /** isSaveがfalseで呼ばれることがないので、ここに来ることはないかも */
      if (this.inspectType == INSPECT_TYPE.RECOMMEND && this.isConfirmRecommend){
        this.saveIsConfirmRecommend();
      }
      /** 2021-05-27 sh #7123 if change price, change the flag. [END] */
    }
  }

  /** 2023-03-28 sh #8188(BQR1084) course does not work for recommend. [START] */
  updateDoTenkenCallApi(
    item: any
    , doTenken: number
    , isSave: any
  ) {
    var promiseAll: any = [];
    /** 2024-03-01 sh #8804(BQRxxx) 赤画面△の「する」「しない」選択操作をした際に 勝手に他部位の「する」「しない」が動く。 MFノースジャパン様 No.25 [START] */
    if (this.timerSave) {
      clearTimeout(this.timerSave);
      this.timerSave = null;
    }
    /** 2024-03-01 sh #8804(BQRxxx) 赤画面△の「する」「しない」選択操作をした際に 勝手に他部位の「する」「しない」が動く。 MFノースジャパン様 No.25 [END] */
    if (isSave) {
      const pMain = this.updateDoTenkenPM(
        this.uketsukeExtendsId
        , doTenken
        , item.sknInspectId
        , item.sknInspectSeibiId
        , item.sknUketsukeManualSeibiId
      );
      promiseAll.push(pMain);
    }
    if (this.inspectType ==INSPECT_TYPE.RECOMMEND  && item.sknInspectDescriptionSeibiId == 0) {
      this.listSeibi.forEach((seibi: any, i: number) => {
        if (seibi.rowNum == 0 && item.sknRecommendInspectCategoryId == seibi.sknRecommendInspectCategoryId
          && seibi.sknInspectDescriptionSeibiId != item.sknInspectDescriptionSeibiId) {
          const pSub = this.updateDoTenkenPM(
            this.uketsukeExtendsId
            , doTenken
            , seibi.sknInspectId
            , seibi.sknInspectSeibiId
            , seibi.sknUketsukeManualSeibiId
          );
          promiseAll.push(pSub);
          this.clickDoTenken(seibi,doTenken,i, isSave, true);
        }
      });
    }
    // 2023-09-00 BQR1092(809) add 明細の並び順とextreme取込 [START]
    if (item.sknInspectType == INSPECT_TYPE.USER_MANUAL || item.inspectResult == INSPECT_TYPE.RECOMMEND_MANUAL) {
      const pSub2 = this.updateDoTenkenPM(
        this.uketsukeExtendsId
        , doTenken
        , item.sknInspectId
        , null
        , item.sknInspectSeibiId
      );
      promiseAll.push(pSub2);
    }
    // 2023-09-00 BQR1092(809) add 明細の並び順とextreme取込 [END]
    // Promise.all(promiseAll.map((p: any) => p.resolve().then())).then((retList: any) => {
    Promise.all(promiseAll).then((retList: any) => {
      /** 2024-03-01 sh #8804(BQRxxx) 赤画面△の「する」「しない」選択操作をした際に 勝手に他部位の「する」「しない」が動く。 MFノースジャパン様 No.25 [START] */
      // const userService = new UserService();
      // userService.autoSaveAk7();
      this.timerSave = setTimeout(() => {
        const userService = new UserService();
        userService.autoSaveAk7();
      }, 2000);
      /** 2024-03-01 sh #8804(BQRxxx) 赤画面△の「する」「しない」選択操作をした際に 勝手に他部位の「する」「しない」が動く。 MFノースジャパン様 No.25 [END] */
    }, ((err: any) => {
      this.$notify.error({
        title: "エラー",
        message: MESSAGE.SystemError
      });
    }));
  }

  updateDoTenkenPM(uketsukeExtendsId: any
  , doTenken: any
  , sknInspectId: any
  , sknInspectSeibiId: any
  , sknUketsukeManualSeibiId: any
  ) {
    const promise = new Promise((resolve: any, reject: any) => {
      this.reqService.updateDoTenken(
        uketsukeExtendsId,
        doTenken,
        sknInspectId,
        sknInspectSeibiId,
        sknUketsukeManualSeibiId
      ).then((res: any) => {
        resolve(res);
      }, (error: any) => {
        this.$notify.error({
          title: "エラー",
          message: MESSAGE.SystemError
        });
        reject();
      });
    });
    return promise;
  }
  /** 2023-03-28 sh #8188(BQR1084) course does not work for recommend. [END] */

  closeTooltip() {
    this.indexTooltip = -1;
  }

  gotoCustomer() {
    this.$router.push({
      name: "usercustomer",
      params: { code: this.yoyakuNo }
    });
  }

  onConnect() {
    if (this.sktControll.checkSocket()) {
      /** 2023-03-28 sh #8188(BQR1084) course does not work for recommend. [START] */
      // memo [start] ほぼ同タイミングで実行されるが、socketInspectSeibiの中身がsocketInspectに送られることが稀にある
      this.sktControll.socketInspect(this.onInspectItemcompleted);//内容分離推奨
      this.sktControll.socketInspectSeibi(this.onInspectcompleted);
      // memo [end]
      this.sktControll.socketInspections(this.onInspectionDotenken);
      /** 2023-12-01 jizen-mitsumori , sync sort-order [START] */
      this.sktControll.socketJizenDisplayOrder(this.onInspectionDotenken);

      /** 2023-12-01 jizen-mitsumori , sync sort-order [End] */
      this.sktControll.socketCustomerEditPrice(this.onEditPrice);
      /** 2023-03-28 sh #8188(BQR1084) course does not work for recommend. [END] */
    }
  }

  //ユーザー画面以外では使っている可能性が残っている
  onInspectItemcompleted(frame: any) {
    const body = util.getWSData(frame);
    const seibi = { ...body };
    delete seibi.sknWorkProgressState;
    delete seibi.sknWorkProgressStateNm;
    this.setSeibiAK3Data(seibi);
  }

  //ユーザー画面以外では使っている可能性が残っている
  onInspectcompleted(frame: any) {
    const body = util.getWSData(frame);
    const seibi = { ...body };
    delete seibi.items.sknWorkProgressState;
    delete seibi.items.sknWorkProgressStateNm;
    this.setSeibiData(seibi);
    this.setListInspectId(this.listInspect(1));
    // this.setListSeibi();
    this.notify();
  }

  onInspectionDotenken(frame: any) {
    // const body = util.getWSData(frame);
    // this.updateDoTenkenFromSocket(body);
    // this.setListSeibi();
    // this.$forceUpdate();
    if (this.inspectType == INSPECT_TYPE.LEGAL56) {
      const userService = new UserService();
      userService.getSeibi();
      userService.getSeibiAK3();
    }
    if (this.isSave) {
      this.isSave = false;
    } else {
      this.notify();
    }
  }

  notify() {
    /** 2023-05-01 sh #8240(BQR1090) add clearTimeout for notify. [START] */
    // this.$notify.info({
    //  title: "Info",
    //  message: MESSAGE.UpdatedInspections
    //});
    clearTimeout(this.timeId);
    this.timeId = setTimeout(() => {
      this.$notify.info({
        title: "Info",
        message: MESSAGE.UpdatedInspections
      });
    }, 1500);
    /** 2023-05-01 sh #8240(BQR1090) add clearTimeout for notify. [END] */
  }

  gotoDetail(item: any) {
    // if (item.sknInspectId) {
    //   this.$router.push({
    //     name: "workdetail",
    //     query: { q: `inspect=${item.sknInspectId.toString()}` }
    //   });
    // } else if (item.sknInspectSeibiId) {
    //   this.$router.push({
    //     name: "workdetail",
    //     query: { q: `seibi=${item.sknInspectSeibiId.toString()}` }
    //   });
    // }
    if (item.sknInspectId) {
      this.$router.push({
        name: "workdetail",
        query: { inspect: item.sknInspectId.toString() }
      });
    } else if (item.sknInspectSeibiId) {
      this.$router.push({
        name: "workdetail",
        query: { seibi: item.sknInspectSeibiId.toString() }
      });
    }
  }

  onConfirmGotoRevNum() {
    if (this.isEditPrice) {
      this.isGoToRevNum = true;
      this.$refs.confirmDialog2.onOpen();
    } else {
      this.$refs.userFooter.onSave();
    }
  }

  onEditPrice(frame: any) {
    const body = util.getWSData(frame);
    this.editPrice(body);
    this.setListSeibi();
    let page = this.inspectType == INSPECT_TYPE.LEGAL56 ? 2 : 3;
    // this.$refs.sideTab.onUpdate(page);
    this.$emit("onUpdateSideTab", page);
    if (this.isSave) {
      this.isSave = false;
    } else {
      this.notify();
    }
  }

  beforeDestroy() {
    if (this.isEditPrice) {
      window.sessionStorage.setItem("seibiEditMode" + this.inspectType, "1");
    } else {
      window.sessionStorage.removeItem("seibiEditMode" + this.inspectType);
    }
  }

  destroyed() {
    this.sktControll.freeSocketResources();
  }

  saveManualAk5(data: any) {
    this.reqService.saveManualAk5(data).then((res: any) => {
    }, (error: any) => {
      this.$notify.info({
        title: "エラー",
        message: MESSAGE.SystemError
      });
    });
  }

  addWork() {
    if (this.manualBuhinNm) {
      /** 2023-10-19 invoice [START] */
      let manualSeibiList: any = [];
      if(this.isExcludingTax){
        manualSeibiList = [{
          seibiNm: this.manualBuhinNm,
          buhinZn: this.manualBuhinKn,
          buhinEditTotalZn: this.manualBuhinKn,
          buhinSelected: STATUS_SELECT_WORK_BUHIN.FakeDone,
          kousuu: 0,
          manualBuhinList: []
        }];
        //manualSeibiList["buhinZn"] = this.manualBuhinKn;
        //manualSeibiList["buhinEditTotalZn"] = this.manualBuhinKn;
      }else{
        manualSeibiList = [{
        seibiNm: this.manualBuhinNm,
          buhinZk: this.manualBuhinKn,
          buhinEditTotalZk: this.manualBuhinKn,
          buhinSelected: STATUS_SELECT_WORK_BUHIN.FakeDone,
          kousuu: 0,
          manualBuhinList: []
        }];
        //manualSeibiList["buhinZk"] = this.manualBuhinKn;
        //manualSeibiList["buhinEditTotalZk"] = this.manualBuhinKn;
      }
      /** 2023-10-19 invoice [END] */
      const data: any = {
        sknUketsukeExtendsId: this.uketsukeExtendsId,
        sknInspectType: INSPECT_TYPE.USER_MANUAL,
        manualSeibiList: manualSeibiList
      };
      this.saveManualAk5(data);
      this.manualBuhinNm = "";
      /** 2023-10-19 invoice [START] */
      this.manualBuhinKn = null;
      /** 2023-10-19 invoice [END] */
    }
  }

  removeWork(e: any, index: number) {
    e.stopPropagation();
    this.tmpDeleteWorkIndex = index;
    this.sknUketsukeManualSeibiId = this.listSeibi[index].sknUketsukeManualSeibiId ? this.listSeibi[index].sknUketsukeManualSeibiId: this.listSeibi[index].sknInspectSeibiId ? this.listSeibi[index].sknInspectSeibiId : 0;
    this.$refs.askDeleteDialog.onOpen();
  }

  onConfirmDelete() {
    const data: any = {
      uketsukeExtendsId: this.uketsukeExtendsId,
      sknUketsukeManualSeibiId: this.sknUketsukeManualSeibiId
    };
    this.reqService.deleteUketsukeManualSeibi(data).then(
      (response: any) => {
        this.listSeibi.splice(this.tmpDeleteWorkIndex, 1);
      },
      (err: any) => {
        console.log(err);
      }
    );
  }

  changeEditMode(e: any, work: any) {
    e.stopPropagation();
    if (work.editMode) {
      work.editMode = false;
    } else {
      work.editMode = true;
    }
    this.$forceUpdate();
  }

  changeManual(item: any) {
    const manualSeibiList: any = [{
      seibiId: item.sknUketsukeManualSeibiId ? item.sknUketsukeManualSeibiId : item.sknInspectSeibiId ? item.sknInspectSeibiId : 0,
      seibiNm: item.sknInspectSeibiDescriptionNm
    }];
    const data: any = {
      sknUketsukeExtendsId: this.uketsukeExtendsId,
      manualSeibiList: manualSeibiList
    };
    this.reqService.updateUketsukeManualSeibi(data).then((res: any) => {
      item.editMode = false;
      this.$forceUpdate();
    }, (error: any) => {
      this.$notify.info({
        title: "エラー",
        message: MESSAGE.SystemError
      });
    });
  }

  onEnterManualBuhinNm(event: any) {
    setTimeout(() => {
      if (event.target) {
        event.target.blur();
      }
      this.$refs.buttonAddWork.$el.focus();
    });
  }

  onEnterManualBuhinZk() {
    this.$refs.buttonAddWork.$el.focus();
  }

  /** 2021-05-27 sh #7123 it does not re-calculate, if edit price of seibi or buhin. [START] */
  itemTotalZk(seibi: SeibiItem) {
    let buhinEditTotalZk = seibi.buhinEditTotalZk;
    let kouchinEditZk = seibi.kouchinEditZk;
    if (seibi.buhinEditTotalZk === null) {
      buhinEditTotalZk = seibi.buhinZk;
    }
    if (seibi.kouchinEditZk === null) {
      kouchinEditZk = seibi.kouchinZk;
    }
    return (buhinEditTotalZk == null ? 0 : buhinEditTotalZk) + (kouchinEditZk == null ? 0 : kouchinEditZk);
  }
  /** 2021-05-27 sh #7123 it does not re-calculate, if edit price of seibi or buhin. [END] */

  /** 2023-10-19 invoice [START] */
  itemTotalZn(seibi: SeibiItem) {
    let buhinEditTotalZn = seibi.buhinEditTotalZn;
    let kouchinEditZn = seibi.kouchinEditZn;
    if (seibi.buhinEditTotalZn === null) {
      buhinEditTotalZn = seibi.buhinZn;
    }
    if (seibi.kouchinEditZn === null) {
      kouchinEditZn = seibi.kouchinZn;
    }
    return (buhinEditTotalZn == null ? 0 : buhinEditTotalZn) + (kouchinEditZn == null ? 0 : kouchinEditZn);
  }
  /** 2023-10-19 invoice [END] */
  /** 2021-05-27 sh #7123 if change price, change the flag. [START] */
  saveIsConfirmRecommend() {
    if (this.inspectType == INSPECT_TYPE.RECOMMEND && this.isConfirmRecommend){
      let paramConfirmSend: any = {
        sknUketsukeExtendsId: this.uketsukeExtendsId,
        isConfirmRecommend: 0,
      };
      this.reqService.saveIsConfirmRecommend(paramConfirmSend).then(() => {
        // this.confirm({ type: this.inspectType, value: 0 }); // サーバ側を更新した後、同期するので、不要なはず。
        this.$emit("onUserConfirmSync");
      }, (error: any) => {
        this.$notify.info({
          title: "エラー",
          message: MESSAGE.SystemError
        });
      });
    }
  }
  saveIsConfirmInspect() {
    if (this.inspectType == INSPECT_TYPE.LEGAL56 && this.isConfirmLegal56){
      let paramConfirmSend: any = {
        sknUketsukeExtendsId: this.uketsukeExtendsId,
        isConfirmInspect: 0,
      };
      this.reqService.saveIsConfirmInspect(paramConfirmSend).then(() => {
        this.$emit("onUserConfirmSync");
      }, (error: any) => {
        this.$notify.info({
          title: "エラー",
          message: MESSAGE.SystemError
        });
      });
    }
  }
  saveIsConfirm() {
    if (
      (this.inspectType == INSPECT_TYPE.LEGAL56 && this.isConfirmLegal56 === 0) ||
      (this.inspectType == INSPECT_TYPE.RECOMMEND && this.isConfirmRecommend === 0)
    ) {
      const isConfirmInspect =
        this.inspectType == INSPECT_TYPE.LEGAL56 ? 1 : this.isConfirmLegal56;
      const isConfirmRecommend =
        this.inspectType == INSPECT_TYPE.RECOMMEND
          ? 1
          : this.isConfirmRecommend;
      const param = {
        sknUketsukeExtendsId: this.uketsukeExtendsId,
        isConfirmInspect,
        isConfirmRecommend,
        isConfirmPayment: this.isConfirmPayment
      };
      this.reqService.saveIsConfirm(param).then(() => {
        // this.confirm({ type: this.inspectType, value: 1 }); // サーバ側を更新した後、同期するので、不要なはず。
        this.$emit("onUserConfirmSync");
      }, (error: any) => {
        this.$notify.info({
          title: "エラー",
          message: MESSAGE.SystemError
        });
      });
    }
  }
  /** 2021-05-27 sh #7123 if change price, change the flag. [END] */
  // 2022-01-31 morisako kobac-free add [START]
  getFreeOfChargeNm() {
    this.reqService.getMSknFreeOfCharge(this.uketsukeExtendsId)
    .then((res: any) => {
      if (res.freeOfChargeNm) {
        this.freeOfChargeNm = res.freeOfChargeNm;
      }
    });
  }
  // 2022-01-31 morisako kobac-free add [END]

  /** 2022-10-19 sh #8066(BQR974) Choose from multiple parts. [START] */
  hasMultipleBuhin(item: any) {
    if (item && item.hasOwnProperty("isHasMultipleBuhin") && item.isHasMultipleBuhin == 1) {
      return "";
    }
    return "d_ni";
  }
  /** 2022-10-19 sh #8066(BQR974) Choose from multiple parts. [END] */
}
